$(document).ready(function () {
    $('.new_product-tabs__radio').on('change', function () {
        var radioDataDef = $(this).attr('data-tab-panel');
        var abcParent = $(this).closest('.product-tabs').find('.product-tabs__panel[data-tab-panel="' + radioDataDef + '"]');

        // Hide all panels
        $('.product-tabs__panel').css('display','none');

        // Display the selected panel
        abcParent.css('display','block');
    });

    $('.main-carousel').flickity({
        // options
        cellAlign: 'left',
        autoPlay: false,
        prevNextButtons: true,
        adaptiveHeight: true
        // contain: true

      });

});

let stickyFtrAtcId = document.querySelector("#ftr_sticky_atc");
let headerAtc = document.querySelector(".cstm_header_atc")
// console.log(headerAtc);
// console.log(stickyFtrAtcId);

if (stickyFtrAtcId) {
    // console.log('inif');
    
    let stickyFtrAtcInput = stickyFtrAtcId.querySelector('.quantity-wrapper input');
    let headerAtcInput = document.querySelector(".cstm_header_atc .quantity-wrapper input");

    stickyFtrAtcId.querySelector('.quantity-wrapper .downer').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });
    stickyFtrAtcId.querySelector('.quantity-wrapper .upper').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });

    headerAtc.querySelector('.quantity-wrapper .upper').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });
    headerAtc.querySelector('.quantity-wrapper .downer').addEventListener("click", function() {
        stickyFtrAtcInput.value = headerAtcInput.value;
    });

}




// if (document.querySelector('.fut_wrapper')) {
//     function stickyAddToCart() {
//         let futWrapper = document.querySelector('.shopify-product-form');
//         let futOffset = futWrapper.offsetTop;
//         futOffset = futOffset + futWrapper.offsetHeight + 200;
    
//         if (futOffset <  window.scrollY) {
//             !document.querySelector('.footer_atc_wrapper') ? document.querySelector('.fut_wrapper').classList.add('footer_atc_wrapper') : null;
//             !document.querySelector('.footer_atc') ? document.querySelector('.fut_atc').classList.add('footer_atc') : null;
//             document.querySelector('.footer_atc_wrapper') ? document.body.style.paddingBottom = document.querySelector('.footer_atc_wrapper').offsetHeight + 'px' : null;
//         }
//         else{
//             document.querySelector('.footer_atc_wrapper') ? document.querySelector('.footer_atc_wrapper').classList.remove('footer_atc_wrapper') : null;
//             document.querySelector('.footer_atc') ? document.querySelector('.footer_atc').classList.remove('footer_atc') : null;
//             document.querySelector('.footer_atc_wrapper') ? null : document.body.style.paddingBottom = 0;
//         }
//     }
//     stickyAddToCart()
    
//     window.addEventListener('scroll',stickyAddToCart)  
// }
